// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Json_encode = require("@glennsl/bs-json/src/Json_encode.res.js");
var JsxRuntime = require("react/jsx-runtime");
var Initialize = require("react-dates/initialize").default;
var Http$ReactHooksTemplate = require("../../common/http.res.js");
var Image$ReactHooksTemplate = require("../../common/image.res.js");
var Utils$ReactHooksTemplate = require("../../common/utils.res.js");
var Filter$ReactHooksTemplate = require("./filter.res.js");
var Organization$ReactHooksTemplate = require("../../settings/organization.res.js");
var DateFilterForm$ReactHooksTemplate = require("./DateFilterForm.res.js");
var ListFilterForm$ReactHooksTemplate = require("./ListFilterForm.res.js");
var TextFilterForm$ReactHooksTemplate = require("./TextFilterForm.res.js");
var EmailFilterForm$ReactHooksTemplate = require("./EmailFilterForm.res.js");
var MsisdnFilterForm$ReactHooksTemplate = require("./MsisdnFilterForm.res.js");
var NumberFilterForm$ReactHooksTemplate = require("./NumberFilterForm.res.js");
var FilterPillsElement$ReactHooksTemplate = require("./FilterPillsElement.res.js");
var CurrentOrganization$ReactHooksTemplate = require("../../CurrentOrganization.res.js");

function FilterForm(props) {
  var currentFilter = props.currentFilter;
  var handleResetFilter = props.handleResetFilter;
  var handleSetFilter = props.handleSetFilter;
  var onApply = props.onApply;
  var onClose = props.onClose;
  var filters = props.filters;
  var match = React.useState(function (param) {
        return {
                applying: false,
                filterId: currentFilter
              };
      });
  var setState = match[1];
  var state = match[0];
  var match$1 = React.useContext(CurrentOrganization$ReactHooksTemplate.authContext);
  var onApplyBtnPress = function (param) {
    Js_promise.then_((function (param) {
            return Promise.resolve((Curry._1(onApply, undefined), Curry._1(onClose, undefined)));
          }), Http$ReactHooksTemplate.fetchPostEncodedJSON("/api/v1/filters", Json_encode.object_({
                  hd: [
                    "filters",
                    Json_encode.list(Filter$ReactHooksTemplate.encode, filters)
                  ],
                  tl: /* [] */0
                })));
  };
  var displayFilters = function (xs) {
    var filter = Filter$ReactHooksTemplate.filterType(xs);
    var tmp;
    switch (filter.TAG) {
      case "Number" :
          tmp = JsxRuntime.jsx(NumberFilterForm$ReactHooksTemplate.make, {
                filter: filter._0,
                onChange: (function (param) {
                    return Curry._1(handleSetFilter, Filter$ReactHooksTemplate.setFilterTypes(param, xs));
                  })
              });
          break;
      case "Date" :
          tmp = JsxRuntime.jsx(DateFilterForm$ReactHooksTemplate.make, {
                filter: filter._0,
                onChange: (function (param) {
                    return Curry._1(handleSetFilter, Filter$ReactHooksTemplate.setFilterTypes(param, xs));
                  }),
                displayFilterPills: false,
                disableDatePicker: false
              });
          break;
      case "List" :
          tmp = JsxRuntime.jsx(ListFilterForm$ReactHooksTemplate.make, {
                filter: filter._0,
                onChange: (function (param) {
                    return Curry._1(handleSetFilter, Filter$ReactHooksTemplate.setFilterTypes(param, xs));
                  })
              });
          break;
      case "Msisdn" :
          tmp = JsxRuntime.jsx(MsisdnFilterForm$ReactHooksTemplate.make, {
                filter: filter._0,
                onChange: (function (param) {
                    return Curry._1(handleSetFilter, Filter$ReactHooksTemplate.setFilterTypes(param, xs));
                  })
              });
          break;
      case "Email" :
          tmp = JsxRuntime.jsx(EmailFilterForm$ReactHooksTemplate.make, {
                filter: filter._0,
                onChange: (function (param) {
                    return Curry._1(handleSetFilter, Filter$ReactHooksTemplate.setFilterTypes(param, xs));
                  })
              });
          break;
      case "FreeText" :
          tmp = JsxRuntime.jsx(TextFilterForm$ReactHooksTemplate.make, {
                filter: filter._0,
                onChange: (function (param) {
                    return Curry._1(handleSetFilter, Filter$ReactHooksTemplate.setFilterTypes(param, xs));
                  })
              });
          break;
      
    }
    return JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("div", {
                        children: Utils$ReactHooksTemplate.humanize(Filter$ReactHooksTemplate.title(xs)),
                        className: "font-medium mb-2"
                      }),
                  tmp
                ],
                className: "text-darkcharcoal"
              });
  };
  var displayDateFilter = function (xs) {
    var filter = Filter$ReactHooksTemplate.filterType(xs);
    var tmp;
    tmp = filter.TAG === "Date" ? JsxRuntime.jsx(DateFilterForm$ReactHooksTemplate.make, {
            filter: filter._0,
            onChange: (function (param) {
                return Curry._1(handleSetFilter, Filter$ReactHooksTemplate.setFilterTypes(param, xs));
              }),
            displayFilterPills: true,
            disableDatePicker: false
          }) : JsxRuntime.jsx(JsxRuntime.Fragment, {});
    return JsxRuntime.jsx("div", {
                children: tmp
              });
  };
  var selectedIndicator = function (xs) {
    var isOpenFilter = state.filterId === Filter$ReactHooksTemplate.id(xs);
    if (Filter$ReactHooksTemplate.isSelected(xs)) {
      return JsxRuntime.jsx("div", {
                  className: "w-6-px h-6-px my-2 rounded-lg " + (
                    isOpenFilter ? "bg-white" : "bg-palatinateblue"
                  )
                });
    } else {
      return JsxRuntime.jsx(JsxRuntime.Fragment, {});
    }
  };
  var displayFilterHeaders = function (xs) {
    var isOpenFilter = state.filterId === Filter$ReactHooksTemplate.id(xs);
    return JsxRuntime.jsx("div", {
                children: JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("div", {
                              children: Utils$ReactHooksTemplate.humanize(Filter$ReactHooksTemplate.title(xs)),
                              className: isOpenFilter ? "font-bold" : ""
                            }),
                        selectedIndicator(xs)
                      ],
                      className: "flex text-sm p-4 justify-between " + (
                        isOpenFilter ? "bg-palatinateblue text-white" : ""
                      ),
                      onClick: (function (param) {
                          var id = Filter$ReactHooksTemplate.id(xs);
                          Curry._1(setState, (function (param) {
                                  return {
                                          applying: state.applying,
                                          filterId: id
                                        };
                                }));
                        })
                    }),
                className: "flex flex-col "
              }, String(Filter$ReactHooksTemplate.id(xs)));
  };
  var displayFilterOptions = function (xs) {
    var isOpenFilter = state.filterId === Filter$ReactHooksTemplate.id(xs);
    return JsxRuntime.jsx("div", {
                children: isOpenFilter ? displayFilters(xs) : JsxRuntime.jsx(JsxRuntime.Fragment, {}),
                className: "flex flex-col " + (
                  isOpenFilter ? "p-4" : ""
                )
              }, String(Filter$ReactHooksTemplate.id(xs)));
  };
  var tmp;
  if (filters) {
    var tail = filters.tl;
    tmp = JsxRuntime.jsxs(JsxRuntime.Fragment, {
          children: [
            Organization$ReactHooksTemplate.name(match$1[0]) === "yesbank" ? JsxRuntime.jsx(JsxRuntime.Fragment, {}) : displayDateFilter(filters.hd),
            JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsx("div", {
                          children: "Active Filters",
                          className: "flex items-center font-normal text-sm h-7"
                        }),
                    $$Array.of_list(Belt_List.mapWithIndex(props.filterPills, (function (i, t) {
                                return JsxRuntime.jsx("div", {
                                            children: JsxRuntime.jsx(FilterPillsElement$ReactHooksTemplate.make, {
                                                  t: t,
                                                  handleResetFilter: handleResetFilter,
                                                  height: "h-7 py-1"
                                                }),
                                            className: "flex flex-wrap mr-1"
                                          }, String(i));
                              })))
                  ],
                  className: "flex flex-wrap text-aurometalsaurus p-5 border-b border-gray-400 gap-2"
                }),
            JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsx("div", {
                          children: $$Array.of_list(Belt_List.map(tail, displayFilterHeaders)),
                          className: "w-1/3 border-r border-gray-400 overflow-y-scroll"
                        }),
                    JsxRuntime.jsx("div", {
                          children: $$Array.of_list(Belt_List.map(tail, displayFilterOptions)),
                          className: "w-2/3 overflow-y-scroll"
                        })
                  ],
                  className: "flex h-full text-darkcharcoal"
                })
          ]
        });
  } else {
    tmp = JsxRuntime.jsx(JsxRuntime.Fragment, {});
  }
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("div", {
                              children: "Filters",
                              className: "text-base font-bold"
                            }),
                        JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx("button", {
                                    children: JsxRuntime.jsx("img", {
                                          className: "w-3",
                                          src: Image$ReactHooksTemplate.closeIcon
                                        }),
                                    style: {
                                      outline: "None"
                                    },
                                    onClick: (function ($$event) {
                                        $$event.preventDefault();
                                        $$event.stopPropagation();
                                        Curry._1(onClose, undefined);
                                      })
                                  }),
                              className: "flex items-center"
                            })
                      ],
                      className: "flex justify-between items-center p-5 border-b text-darkcharcoal bg-antiflashwhite"
                    }),
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx(JsxRuntime.Fragment, {
                            children: Caml_option.some(tmp)
                          }),
                      style: {
                        height: "100%",
                        overflow: "scroll"
                      }
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("button", {
                              children: "Apply",
                              className: "bg-palatinateblue text-white float-right h-10 w-32 rounded",
                              id: "filter_apply",
                              onClick: onApplyBtnPress
                            }),
                        JsxRuntime.jsx("button", {
                              children: "Cancel",
                              className: "text-darkcharcoal float-right h-10 w-24 mr-4 border border-gray-400 rounded",
                              id: "filter_close",
                              onClick: (function ($$event) {
                                  $$event.preventDefault();
                                  Curry._1(onClose, undefined);
                                })
                            })
                      ],
                      className: "h-20 border-t p-5"
                    })
              ],
              className: "flex flex-col " + (
                state.applying ? "animate-pulse pointer-events-none" : ""
              ),
              style: {
                height: "100%"
              }
            });
}

var make = FilterForm;

exports.make = make;
/*  Not a pure module */
